import gql from 'graphql-tag';

const GET_DEVICE_USERS_BY_DEVICE = gql`
  query GetDeviceUsersByDevice($deviceId: ID!) {
    getDeviceUsersByDevice(deviceId: $deviceId) {
      deviceUsers {
        id
        deviceId
        identifier
        firstName
        lastName
        phoneNumbers
        userIdentifier
        confirmation_code
        duress_code
        cra_code
        image
        deviceUserPartition {
          id
          devicePartitionName
          devicePartitionIdentifier
          deviceUserId
          devicePartitionId
        }
        deviceUserCategory {
          id
          description
        }
      }
      aggregate {
        rows
      }
    }
  }
`;

export default {
  GET_DEVICE_USERS_BY_DEVICE,
};
